<section class="recent-updates-section py-5 position-relative">
  <div class="container">
    <div class="section-header text-center mb-5">
      <h2 class="heading-two">Read Our Latest Tech Insights and Success Stories </h2>
      <!-- <h3 class="heading-three">Empower Your Knowledge</h3> -->
    </div>

    <div class="row gx-3">
      <!-- Main Carousel -->
      <div class="col-lg-5 col-md-12 mb-3 mb-lg-0">
        <div class="carousel-container">
          <div class="carousel-wrapper">
            <div class="carousel-slides d-flex" [style.transform]="'translateX(' + (-currentSlide * 100) + '%)'">
              <!-- Added click event here -->
              <div class="slide flex-shrink-0 w-100" *ngFor="let slide of slides; let i = index"
                (click)="onSlideClick(slide)" style="cursor: pointer;">
                <div class="slide-image-container">
                  <img [src]="slide.image" [alt]="slide.title" class="slide-image">
                </div>
                <div class="slide-overlay">
                  <h3 class="slide-title">{{ slide.title }}</h3>
                  <div class="slide-action">
                    <span class="action-text">{{ slide.actionText }}</span>
                    <span class="arrow-icon">→</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-dots">
            <button *ngFor="let slide of slides; let i = index" class="indicator border-0"
              [class.active]="i === currentSlide" (click)="goToSlide(i)">
            </button>
          </div>
        </div>
      </div>

      <!-- Small Cards (2 cards) -->
      <div class="col-lg-3 col-md-6 mb-3 mb-lg-0">
        <div class="small-cards">
          <!-- Added cursor style -->
          <div class="card" *ngFor="let card of smallCards.slice(0,2)" (click)="onCardClick(card)"
            style="cursor: pointer;">
            <div class="card-img-container">
              <img [src]="card.image" [alt]="card.title" class="card-img">
            </div>
            <div class="card-overlay">
              <h6 class="card-title">{{ card.title }}</h6>
              <div class="card-action">
                <span class="action-text">{{ card.actionText }}</span>
                <span class="arrow-icon">→</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Large Card (1 card) -->
      <div class="col-lg-4 col-md-6">
        <div class="large-card">
          <!-- Added cursor style -->
          <div class="card" *ngIf="smallCards[2]" (click)="onCardClick(smallCards[2])" style="cursor: pointer;">
            <div class="card-img-container">
              <img [src]="smallCards[2].image" [alt]="smallCards[2].title" class="card-img">
            </div>
            <div class="card-overlay">
              <h5 class="card-title">{{ smallCards[2].title }}</h5>
              <div class="card-action">
                <span class="action-text">{{ smallCards[2].actionText }}</span>
                <span class="arrow-icon">→</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>